import { render, staticRenderFns } from "./google.vue?vue&type=template&id=18392d6b&"
import script from "./google.vue?vue&type=script&lang=js&"
export * from "./google.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports